<button
  type="button"
  class="btn btn-dark btn-lg btn-block rounded-0 border-0 text-left d-flex flex-row"
  [routerLink]="['storyboard', storyboard.id]"
  (click)="SendStoryboardEvent()"
>
  <div class="thumbnail-container" *ngIf="thumbnailFile">
    <video
      *ngIf="isVideo"
      [src]="thumbnailFile.fileUrl + '#t=0.1'"
      preload="auto"
      muted
      class="thumb-media"
    ></video>
    <img
      *ngIf="!isVideo"
      [src]="thumbnailFile.fileUrl"
      class="thumb-media"
      alt="Thumbnail"
    />
    <div class="play-overlay" *ngIf="isVideo">
      <svg viewBox="0 0 24 24" fill="white" width="24" height="24">
        <polygon points="5,3 19,12 5,21" />
      </svg>
    </div>
  </div>

  <div class="p-3 ml-3 d-flex flex-column wrapp-title">
    <span class="storyboard-title p-0 mb-0 font-weight-light">{{
      storyboard.displayName
    }}</span>
    <!--guarding if the files are undefined -->
    <span class="storyboard-documents p-0 text-secondary text-uppercase"
      >{{ storyboard.files?.length }}
      {{ storyboard.files?.length === 1 ? "document" : "documents" }}</span
    >
  </div>

</button>
